<template>
<div>
        <b-navbar class="blogSpanHeader" toggleable="lg" type="dark" variant="dark" v-if="formatedTableValuesPreFilter">
           <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
                     <b-navbar-brand class="ml-2">Completed ({{ formatedTableValueFilter.length }})</b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
              <b-navbar-nav>
        <b-nav-form class="ml-2">
          <b-form-input class="ml-2 textInputSize" size="sm"  type="text" v-model="searchBusiness" placeholder="Business Name"></b-form-input>
          <b-form-input class="ml-2 textInputSize" size="sm"  type="text" v-model="searchAddress" placeholder="Address"></b-form-input>
          <b-form-input class="ml-2 textInputSize" size="sm"  type="text" v-model="searchAssigned" placeholder="Author"></b-form-input>
      
      <b-form-radio-group  class="ml-3" size="sm"  id="radios2" v-model="sortBySelected" name="radioSubComponent">
        <b-form-radio :value="false" class="text-light">Exact</b-form-radio>
        <b-form-radio :value="true" class="text-light">Contains</b-form-radio>
      </b-form-radio-group>
      <b-form-checkbox class="text-light" v-model="showOutstanding">Show Outstanding</b-form-checkbox>
        </b-nav-form>
              </b-navbar-nav>
                    </b-collapse>
          <b-navbar-nav class="ml-auto">
            </b-navbar-nav>
            
      </b-navbar>
      <b-navbar type="dark" variant="dark"> 
        <b-navbar-brand class="ml-2">Date Range</b-navbar-brand>
        <b-nav-form class="ml-2">
          <b-form-input type="date" v-model="filterDateStart" />
          <b-form-input class="ml-2" type="date" v-model="filterDateEnd" />

        </b-nav-form>
        <b-btn variant="outline-info"  @click="FileProcess" v-if="dataViewMode == 'Table'">Download</b-btn>
      </b-navbar>
     <b-table v-if="dataViewMode == 'Table'" :fields="fields" :items="formatedTableValueFilter" :per-page="10" :current-page="currentPage" stacked="lg">
        <template slot="select" slot-scope="data">
          <b-form-checkbox v-model="data.item.select" />
        </template>
        <template slot="inspectionCompletedDate" slot-scope="data">
            <b-btn variant="link" @click="openInspection = true, inspectionPDF = data.item.inspectionFinalPdf">{{ getDateFormat(data.item.inspectionCompletedDate) }}</b-btn>
        </template>
        <template slot="complete" slot-scope="data">
          <b-btn variant="outline-info" size="sm" @click='emitNewInspection(data.item)'>Complete</b-btn>
        </template>
        <template slot="Previous Visits" slot-scope="data">
            <b-badge :variant="getBadgeVariant(data.item).variant">{{ getBadgeVariant(data.item).number }}</b-badge>
        </template>
        <template slot="Violations" slot-scope="data">
          <b-badge :variant="data.item.inspectionViolations.length > 0 ? 'danger' : 'success'">{{ data.item.inspectionViolations.length }}</b-badge>
        </template>
        <template slot="Remove" slot-scope="data">
          <b-btn :disabled="true" variant="outline-danger" size="sm" @click='deleteItem(data)'>Delete</b-btn>
        </template>
      </b-table>
       <b-pagination class="pt-2" align="center" size="md" v-if="formatedTableValueFilter && dataViewMode == 'Table'" :total-rows="formatedTableValueFilter.length" v-model="currentPage" :per-page="10" />
      <businessMap v-if="dataViewMode == 'Map'" :responseView="false" :availableBusiness="formatedTableValueFilter" @showBusiness="emitItem($event)" />
  <b-modal v-model="openInspection" title="Inspection View" size="lg">
    <div v-for="(pdfItem, index) in parseData(inspectionPDF)" :key="index">
    <b-img :src="pdfItem.inspection" responsive />
    </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { bus } from '../../../main'
import axios from 'axios'
import printJS from 'print-js'
import DatePicker from '../../inputfields/Datepickermod.vue'
import TimePicker from '../../inputfields/timepicker.vue'
import moment from 'moment'
import Leaf from 'leaflet'
import PapaParse from 'papaparse';
import businessMap from './inspectionMap.vue'
import querystring  from 'querystring';
import Multiselect from 'vue-multiselect'
import arrayData from '../../../../files/dispatchReport.js'
import convert from 'xml-js'
export default {
  props:["formTableStyle", "submittedBusiness", "inspectionsData"], 
components:{
      'businessMap' : businessMap,
      'timepicker' : TimePicker,
      'multiselect' : Multiselect,
      'datepicker' : DatePicker,

},
  data () {
    return {
        searchGrid: '',
        inspectionPDF: null,
        openInspection: false,
        searchBusiness: '',
        searchStation: '',
        searchAddress: '',
        searchAssigned: '',
        currentPage: 1,
        filterDateStart: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        filterDateEnd: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        showOutstanding: false,
        holdValues: {},
        taxonomyScheduleId: null,
        patchData: false,
        completedLoad: false,
        ppObj: {},
        fields: [],
        tableRows: [],
        formatedTableValuesPreFilter: [],
        jsonArray: [],
        buildData: [],
        mapStatus: 'both',
        disableMapStatus: false,
        dataViewMode: 'Table',
        sortBySelected: true,
        windowWidth: '',
        previouslyCompletedInspections: [],
        // Tracks every inspection id we've already requested (or already have),
        // so the fetch-chain never re-requests the same id twice. This is the
        // core fix for the memory leak: previously this de-dupe check compared
        // a raw id against an array of *objects*, which never matched, so every
        // render re-issued every request in the chain forever.
        fetchedInspectionIds: new Set(),
    }
  },
  created(){
  var data = arrayData.arrayData
  this.getWindowWidth()
  window.addEventListener('resize', this.getWindowWidth);
  var jsonArray = []
  for(var i in data){
    var result = convert.xml2json(data[i], {compact: true, spaces: 0})
    var parsed = JSON.parse(result)
    jsonArray.push(parsed)
  }
    this.buildData = []
   this.jsonArray = jsonArray
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
  mounted(){
    var data = _.cloneDeep(this.submittedBusiness)
    var inspections = _.cloneDeep(this.inspectionsData)
    this.buildTableData(this.formTableStyle, data)
    this.setupTableValues(this.formTableStyle, inspections, data)
  
  },
  computed:{
    ...mapState([
          'getSessionData',
          'stationsData',
          'apparatusData',
          'userData',
          'shiftsData',
          'Businesstatus',
          'deptContactData'
        ]),
        documentWidth(){
          if(this.windowWidth > 992){
            var boo = true
          } else {
             var boo = false
          }
          return boo
        },
        formatedTableValueFilter(){
          var array = this.formatedTableValues
          if(this.showOutstanding){
            var bArray = [...new Set(array.map(p => p.inspectionBusinessId))]
            var rArray = []
            for(var b in bArray){
              var obj = array.find(p => p.inspectionBusinessId == bArray[b])
              if(obj.inspectionViolations && obj.inspectionViolations.length > 0){
                rArray.push(obj)
              }
            }
            return rArray
          } return array
        },
        // NOTE: this is a computed getter, so it must stay pure (no network calls,
        // no pushing to reactive state). Fetching "previous visit" data now happens
        // in the `formatedTableValues` watcher below instead. Previously a call to
        // getPreviousInspectionData() lived at the end of this getter, which meant
        // every re-render re-triggered fetches, which (combined with the de-dupe
        // bug) pushed to reactive state forever -> re-render -> re-fetch -> ...
        // an unbounded loop that eventually exhausted browser memory.
        formatedTableValues(){
          if(this.searchGrid){
          var grid = this.formatedTableValuesPreFilter.filter(p => {
                  if(this.searchGrid){ 
                  return p.gridNumber.toString().match(this.searchGrid.toString())
                  } else {
                    return p
                  }
          })
        } else { var grid = this.formatedTableValuesPreFilter }
        if(this.searchStation){
          var station = grid.filter(p => {
            return  p.primaryStation.includes(this.searchStation)
          })
         } else { var station = grid }
          if(this.searchBusiness){
           var business = station.filter(p => {
             if(this.sortBySelected){
               var searchOpt = this.searchBusiness.toLowerCase().split(' ')
               var searchResult = true
               for(var i in searchOpt){
                 var index = p.businessName.toLowerCase().includes(searchOpt[i])
                   if(!index){
                     searchResult = false
                   }
                 }
                 if(searchResult){
                   return p
                 }
               
             } else {
                return p.businessName.toLowerCase().includes(this.searchBusiness.toLowerCase()) 
             }
           })
         } else { var business = station   }
         var map = business.filter(p => {
                 if(this.mapStatus == false){

                    if(!p.map){
                      return p
                    }
                  } else if (this.mapStatus == true){
                    if(p.map){
                      return p
                    }
                  } else {
                    return p
                  }
         })
         if(this.searchAddress){
           var address = map.filter(p => {
             if(this.sortBySelected){
               var searchOpt = this.searchAddress.toLowerCase().split(' ')
               var searchResult = true
               for(var i in searchOpt){
                 var index = p.streetNumberStreetStreetSuffix.toLowerCase().includes(searchOpt[i])
                   if(!index){
                     searchResult = false
                   }
                 }
                 if(searchResult){
                   return p
                 }
               
             } else {
                return p.streetNumberStreetStreetSuffix.toLowerCase().includes(this.searchAddress.toLowerCase()) 
             }
           })
         } else {
           var address = map
         }
        if(this.searchAssigned){
           var assigned = address.filter(p => {
             if(p.inspectionAuthor){
            return  p.inspectionAuthor.toLowerCase().includes(this.searchAssigned.toLowerCase())
             }
           })
         } else {
           var assigned = address
         }
         console.log('PRE-FILTER-DATE')
         console.log(assigned)
         if(this.filterDateStart && this.filterDateEnd){
           assigned = assigned.filter(p => {
              return moment(p.inspectionCompletedDate).isSameOrAfter(moment(this.filterDateStart, 'YYYY-MM-DD'))
                  && moment(p.inspectionCompletedDate).isSameOrBefore(moment(this.filterDateEnd, 'YYYY-MM-DD'))
           })
           console.log('FILTER ASSIGNED')
           console.log(assigned)
         }
         return _.orderBy(assigned, ['inspectionCompletedDate'], ['desc'])
        },
    
    

    },
  // Removed the `watch` on formatedTableValues that called
  // getPreviousInspectionData() here. That triggered a real HTTP request for
  // every inspection with a previousId, then chained one more sequential
  // request per hop back through that business's history - for ~100 filtered
  // rows with real chain depth, that's the "requests going out one at a
  // time" waterfall. The data needed to answer "how many previous visits"
  // is already sitting in `inspections` (the full ~7600-row array passed
  // into setupTableValues/buildBusinesses) - filterDateStart/filterDateEnd
  // only filter the already-loaded array client-side, they don't re-fetch
  // it. So the count is now computed once, synchronously, in setupTableValues
  // via the same countInspectionChain() already used in buildBusinesses, and
  // stored directly on each row as `previousVisitCount`. getBadgeVariant
  // below just reads it. See setupTableValues for the one caveat: if a
  // chain's real history extends further back than what's in `inspections`,
  // this will undercount rather than reach out over the network for the
  // rest - flagged there in more detail.
  methods:{
    FileProcess(){
        var json_data = _.cloneDeep(this.formatedTableValueFilter)
        json_data = json_data.map(p => {
            var obj = {}
            obj['InspectionCompleted'] = p.inspectionCompletedDate
            obj['Business_id'] = p.id
            obj['Business'] = p.businessName
            obj['Address'] = p.streetNumberStreetStreetSuffix
            obj['Billing'] = p.billingAdd
            obj['Author'] = p.inspectionAuthor
            obj['Violations'] = p.inspectionViolations.length
            obj['InspectionFee'] = p.inspectionInvoiceAmount
            return obj
        })
        const fileName = 'Inspections Completed' + moment().format('YYYY-MM-DD-HHmm') + '.csv';
        const data = PapaParse.unparse(json_data)
        var csvData = new Blob([data], {type: 'text/csv;charset=utf-8;'});
        var csvURL =  null;
        if (navigator.msSaveBlob)
        {
            csvURL = navigator.msSaveBlob(csvData, fileName);
        }
        else
        {
            csvURL = window.URL.createObjectURL(csvData);
        }
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = csvURL;
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
      },
    parseData(data){
     /// console.log(data)
      if(data){
        var array = data.map(item => JSON.parse(item))
       // console.log(array)
        return array
      }
    },
    getTaggedType(type, id){
      var array = this[type]
      if(array){
      var obj = array.find(p => p.id == id)
      if(obj){
        return type == 'apparatusData' ? obj.apparatusName : type == 'stationsData' ? obj.stationName : type == 'deptContactData' ? obj.firstName + ' ' + obj.lastName : "Unknown"
      } else {
        return null
      }
      } else {
        return null
      }
    },
    getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;
    },
    emitNewInspection(data){
      if(data){
        this.$emit('createScheduledInspection', data)
      }
    },
    getOptionsFromSelection(data){
    if(data){
     // console.log(data)
    return this[data]
    } else {
      return []
    }
    },
    getDateFormat(data){
      if(data){
        return moment(data).format('MM/DD/YYYY HH:mm')
      } else {
        return 'invalid'
      }
    },
    getDateFormatTitle(data, author){
      if(data){
        var time = moment(data).format('MM/DD/YYYY HH:mm')
        return 'Scheduled for ' + time + ' by ' + author
      } else {
        return 'invalid'
      }
    },
    buildTableData(table, data){
      // Was: console.log('build table', data) - printing the full array to an
      // open DevTools console gets expensive fast at real data volumes, and
      // compounds with the other fixes below. Log the count instead.
      console.log('build table', data.length)
      for(var i in table){
        var obj = {key: table[i].key, label: table[i].label, include: true }
        this.fields.push(obj)
      }
      this.fields.push({key: 'inspectionCompletedDate', label: 'Completed'})
      this.fields.push({key: 'inspectionAuthor', label: 'Author'})
      this.fields.push('Violations')
      this.fields.push('Previous Visits')
      if(this.userData.role == 'admin'){
        this.fields.push('Remove')
      }
     
    },
    getInspectionsView(id){
      this.$emit('getInspectionsView', id)
    },
    setupTableValuesLoop(obj, vals){
        for(var p in vals){
          if(vals[p].key != 'map'){
          obj[vals[p].key] = vals[p].value
          } else if (vals[p].key == 'map'){
            obj[vals[p].key] = vals[p]
          }
        }  
      return obj
    },
      buildBusinesses(rawBusinesses, rawInspections) {
    const inspectionMap = new Map(rawInspections.map(i => [i.id, i]))

    const previousIds = new Set(
      rawInspections
        .map(i => i.inspectionPreviousId)
        .filter(Boolean)
    )

    // Find the latest inspection per business (head of each chain)
    const latestByBusiness = rawInspections
      .filter(i => !previousIds.has(i.id))
      .reduce((acc, inspection) => {
        const bizId = inspection.inspectionBusinessId
        const existing = acc.get(bizId)
        if (!existing || new Date(inspection.inspectionDate) > new Date(existing.inspectionDate)) {
          acc.set(bizId, inspection)
        }
        return acc
      }, new Map())

    var businesses = rawBusinesses.map(business => {
      const latest = latestByBusiness.get(business.id)
      return {
        ...business,
        lastInspection: latest ? {
          ...latest,
          previousVisitCount: this.countInspectionChain(latest.inspectionPreviousId, inspectionMap)
        } : null
      }
    })
    console.log('businesses', businesses.length)
    // Removed: an `inspectionMapBus` block used to be built here via a nested
    // `.find()` inside a `.map()` (O(businesses^2)) purely so it could be
    // console.logged under a 'claudecode' tag. Its result was never assigned
    // anywhere or returned - it was dead code that still did real, expensive
    // work every mount. At ~2000 businesses that's several million redundant
    // comparisons, plus the cost of printing a same-sized array to an open
    // DevTools console. This was a major contributor to the freeze on larger
    // datasets. `businesses` itself is also currently unused by the caller -
    // if that data is needed later, return it from this method instead of
    // recomputing it.
  },

  countInspectionChain(inspectionId, inspectionMap, count = 0, seen = new Set()) {
    // Cycle guard: if inspectionPreviousId ever loops back on itself (a bad
    // manual edit, a copy/paste error, etc.), this recursion would otherwise
    // keep growing the call stack until it throws a stack-overflow error,
    // aborting mounted() partway through - which would also explain logs
    // stopping mid-sequence with no further output. Mirrors the same `seen`
    // guard added to getBadgeVariant().
    if (!inspectionId) return count
    if (seen.has(inspectionId)) return count
    seen.add(inspectionId)
    const inspection = inspectionMap.get(inspectionId)
    if (!inspection) return count
    return this.countInspectionChain(inspection.inspectionPreviousId, inspectionMap, count + 1, seen)
  },
    setupTableValues(table, inspections, dataArray){
      // Was: console.log('inspections', inspections.filter(...)) - printing a
      // filtered copy of the full inspections array. Log the count instead.
      // Also logging the raw total here - the Outstanding table's debugging
      // showed the "with violations" count (3921) was only a filtered
      // subset of a much larger raw inspections array (7612). Worth knowing
      // this table's real input size too.
      console.log('inspections total', inspections.length, '- with violations', inspections.filter(p => p.inspectionViolations.length > 0).length)
      this.buildBusinesses(dataArray, inspections)
      var keys = this.fields.filter(p => p.include)
      keys = keys.map(p => p.key)
      // Build the business lookup once as a Map instead of calling
      // dataArray.find(...) inside the loop below. The old version was
      // O(inspections x businesses) - with ~3900 inspections and ~2000
      // businesses that's several million comparisons on every mount, done
      // twice per page (Completed + Outstanding). A Map lookup is O(1) per
      // inspection, so this becomes O(inspections + businesses).
      var businessById = new Map(dataArray.map(b => [b.id, b]))
      // Full id -> inspection lookup built from the *entire* local inspections
      // array (all ~7600, not just the filtered/displayed rows). This is what
      // lets previousVisitCount be computed below with zero network requests.
      var inspectionById = new Map(inspections.map(i => [i.id, i]))
      var inspectionMap = inspections.map(item => {
              var obj = item
              obj['business'] = businessById.get(item.inspectionBusinessId)
              var tableData = obj.business && obj.business.businessTableData ? obj.business.businessTableData : []
              obj['assigned'] =  this.getTaggedType(item.inspectionAssignedType,item.inspectionAssignedId)
              for(var k in keys){
                var value = tableData.find(p => p.key == keys[k])
                obj[keys[k]] = value && value.value ? value.value : 'Unknown' 
              }
              // Walks this row's OWN previousId chain through the local
              // inspection map - same countInspectionChain() used in
              // buildBusinesses, just applied per-row here instead of
              // per-business. Synchronous, no network calls.
              // Caveat: if a chain's real history reaches further back than
              // what's loaded in `inspections`, countInspectionChain simply
              // stops when it can't find the next id locally (see its `if
              // (!inspection) return count` case) rather than treating that
              // as an error - so this can silently undercount for a business
              // whose full history isn't in this dataset. Given `inspections`
              // is ~7600 rows and isn't re-fetched when the date filter
              // changes, it's very likely the full history already - worth
              // spot-checking one business you know has a long inspection
              // record to confirm the count matches expectations. If it
              // turns out some chains genuinely extend past what's loaded,
              // the fix is a targeted fetch only for those specific
              // truncated chains, not a full return to fetching every hop.
              obj['previousVisitCount'] = this.countInspectionChain(item.inspectionPreviousId, inspectionById)
              // Object.freeze is the fix that actually solved the Outstanding
              // table's freeze: `formatedTableValuesPreFilter` below is a
              // reactive Vue data property, so on assignment Vue 2 recursively
              // walks every object in the array and converts every property to
              // a getter/setter to track future mutations. For up to ~7600
              // inspections, each carrying a nested full business object
              // (including business.business TableData), that walk is exactly
              // the kind of thing that can silently eat several seconds and
              // look like a freeze - it just happened not to be the dominant
              // cost here yet. Vue's observer explicitly skips frozen objects,
              // so this tells it "don't bother watching this, it's read-only."
              // Same caveat as Outstanding: the "select" slot in the template
              // (v-model="data.item.select") would silently fail to mutate a
              // frozen row. It isn't wired into `this.fields` here either, so
              // it doesn't appear to be in active use - worth a quick check
              // before relying on this.
              return Object.freeze(obj)

      })


      this.formatedTableValuesPreFilter = inspectionMap
    },
    getItemMap(item){
      if(!item){
          var southWest= {lat: 27.128813241669747, lng: -82.99415588378908}
          var northEast = {lat: 27.54480631775389, lng: -82.03765869140626}
          var lngSpan = northEast.lng - southWest.lng
          var latSpan = northEast.lat - southWest.lat
          return {obj: {y: southWest.lat + latSpan * Math.random(), x: southWest.lng + lngSpan * Math.random()}}
      } else {
        return item
      }
    },
    // Kicks off fetches for any inspection ids referenced by `inspectionPreviousId`
    // that we haven't already requested. `fetchedInspectionIds` is the source of
    // truth for "already asked for" - it's populated the moment a request is
    // *started*, not when it resolves, so overlapping calls to this method
    // (e.g. from rapid filter changes) can't double-fire requests for the same id.
    // No longer called automatically (the watcher that triggered this on
    // every filter change was removed - see the comment above `methods:`).
    // previousVisitCount is now computed locally in setupTableValues instead.
    // Left in place only as a building block in case some chains genuinely
    // extend past what's loaded in `inspections` and a targeted fallback
    // fetch turns out to be needed for those specific cases.
    getPreviousInspectionData(data){
      var holdMap = data
      var ids = holdMap.map(p => p.inspectionPreviousId)
      ids = ids.filter(Boolean)
      var newIds = ids.filter(id => !this.fetchedInspectionIds.has(id))
      if(newIds.length > 0){
        for(var i in newIds){
          this.fetchedInspectionIds.add(newIds[i])
          this.axiosPullLoop(newIds[i])
        }
      }
    },
    axiosPullLoop(id){
      axios({
        method: "get",
        url: "/api/v1/preplan/inspection/" + id,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json",
        }
      }).then(response => {
           if(response.data && response.data[0]){
             var obj = response.data[0]
             var index = this.previouslyCompletedInspections.findIndex(p => p.id == obj.id)
             if(index == -1){
               this.previouslyCompletedInspections.push(obj)
             }
             if(obj.inspectionPreviousId && !this.fetchedInspectionIds.has(obj.inspectionPreviousId)){
               this.fetchedInspectionIds.add(obj.inspectionPreviousId)
               this.axiosPullLoop(obj.inspectionPreviousId)
             }
           }
        })
    //    console.log(this.previouslyCompletedInspections)
    },
    getBadgeVariant(obj){
      // Was: walked this.previouslyCompletedInspections (populated one
      // network request at a time via axiosPullLoop) to re-derive the same
      // count that's now precomputed on `obj.previousVisitCount` during
      // setupTableValues. No network dependency, no chain walk here at all.
      if(!obj){
        return {variant: 'secondary', number: 'Unk'}
      }
      var count = obj.previousVisitCount || 0
      if(count === 0){
        return {variant: 'success', number: 0}
      }
      if(count < 3){
        return {variant: 'warning', number: count}
      }
      return {variant: 'danger', number: count}
    },
    emitItem(data){
   //   console.log('data')
      var obj = this.submittedBusiness.find(p => p.id == data)
      this.$emit('showbusiness', obj)
    },
    deleteItem(data){
   //   console.log(data)
  
            axios({
        method: "delete",
        url: "/api/v1/preplan/inspection/" + data.item.id,
        data: data,
        headers: {
          Authorization: this.getSessionData,
          "Content-Type": "application/json",
        }
      }).then(response => {
           this.$emit('getInspections')
        })
    },
    getTableItems(display, fields){
      var fieldSort = fields.filter(p => p.order == display)
       var obj = {}
      for(var i in fieldSort){
        var key = fieldSort[i].idtag
        var value = this.holdValues[fieldSort[i].vmodel].value
        if(value == undefined){
          value = 'Not Entered'
        }
        if(fieldSort[i].type == 'computed'){
          value = this.getComputedValues(fieldSort[i])
        }
        if(fieldSort[i].type == 'taxonomySingleSelect'){
          value = this.holdValues[fieldSort[i].vmodel].value[fieldSort[i].taxitem]
        }
        if(fieldSort[i].type == 'reference'){
          value = this.holdValues[fieldSort[i].reference].value[fieldSort[i].refitem]
        }
        obj[key] = value
      }
    var arr = []
    arr.push(obj)
    return arr
    },
    getComputedValues(data){
      var array = []
      for(var i in data.ref){
        var hold = this.holdValues[data.ref[i]].value
        if(hold != undefined && hold != null && hold != ''){
          array.push(hold)
        }
      }
      var operator = function(a, b){ return a * b}
      var holdValue = 0
      for(var i in array){
        if(i == 0){
          var item = operator(array[i], array[1])

          holdValue = item
        } else if(i > 1) {
           var item = operator(holdValue, array[i]) 
        }
      }
      return holdValue
    },
    getDescendantProp(obj, desc) {
    var arr = desc.split(".");
    while(arr.length && (obj = obj[arr.shift()]));
    return obj;
    },


}
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.datepickervue {
  width: 300px;
}
.A-shift {
    background: #fff;
  color: #e2070d;
}
.B-shift {
    background: #fff;
  color: #201B9F;
}
.C-shift {
    background: #fff;
  color: #0FB906;
}
.multiselect__option--highlight {
  background: #f0454a
}
span.custom__tag {
  position: relative;
  display: inline-block;
  padding: 4px 10px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #f0454a;
  margin-bottom: 8px;
  white-space: nowrap;
}
span.custom__remove {
  color: #444;
  font-weight: bold;
  margin-left: 3px;
  font-size: 14px;
  cursor: pointer;
}
</style>
<style scoped>
.numberInputSize {
  width: 70px;
}
.textInputSize {
  width: 140px;
}
.textAreaDescription {
  margin-top: 10px;
}
span{
  margin-bottom: 10px;
}
.multiselect{
  margin-bottom: 15px;
}
.itemDescription {
  margin-top: 10px;
  border-style: solid;
    border: 1px solid #bbb;
}
#tablePassDown{
  margin: 0;
  padding: 0;
}
.sub-section-heading {
color: White;
background: #aaa;
width: 100%;
border-radius: 5px;
padding: 7px;
text-align: center;
margin-top: 10px;
margin-bottom: 10px;
margin-right: 0;
margin-left: 0;
}
textarea {
  width: 100%;
  border-radius: 5px;
}
.centerTheHeading {
  text-align: center;
}
.genLeft h3 {
  margin-right: 30px;
  text-align: right;
}
.genCenter {
  text-align: center;
}
.removeButton {
  background: white;
  color: red;
  border: 1px solid red;
  border-radius: 50%;
  margin: 0;
}
input {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
}
span.defDescrip {
  border: 1px solid red;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  margin-left: 40px;
}
span.Yes {
  background: green;
  color: white;
  padding: 3px;
}
span.No {
  background: red;
  color: white;
  padding: 3px;
}
table {
  width: 100%;
  text-align: center;
}
tr.headerRows {
  background: #aaa;
  font-weight: bold;
}
#confirmationTable td {
    padding: 5px;

}
.selectedButtonGreen {
  background: green;
  color: white;
}
.selectedButtonRed {
  background: red;
  color: white;
}
#todaysDateDisplay {
  margin-bottom: 0;
  cursor: pointer;
  color: red;
}
#logbookBody {
  margin-top: 60px;
  width: 100%;
}
.addNewArticle {
  border-radius: 50%;

}
.addNewArticle:hover {
  background: grey;
}
.timeMobile{
  display: none;
}
.datePickerClassMobile {
  display: none;
}
@media screen and (max-width: 992px) {
  .time-picker.timeDesk{
    display: none;
  }
    .datePickerClass {
    display: none;
  }
  .datePickerClassMobile {
    display: block;
  }
  .timeMobile{
    display: block;
    min-width: 120px;
    max-width: 150px;
  }
}


</style>